import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useToast } from '@percent/lemonade'

type TemplateLike = {
  id: string
  name: string
}

type UseArchiveTemplateProps = {
  archiveTemplate: (templateId: string) => Promise<unknown>
  onArchived: VoidFunction
}

export const useArchiveTemplate = <T extends TemplateLike>({
  archiveTemplate,
  onArchived
}: UseArchiveTemplateProps) => {
  const { t } = useTranslation()
  const { addToast } = useToast()
  const [templateToArchive, setTemplateToArchive] = useState<T | null>(null)
  const [isArchiving, setIsArchiving] = useState(false)

  const handleArchive = async () => {
    if (!templateToArchive) {
      return
    }

    setIsArchiving(true)

    try {
      await archiveTemplate(templateToArchive.id)
      addToast(t('toast.templates.archiveSuccess'), 'success')
      setTemplateToArchive(null)
      onArchived()
    } catch {
      addToast(t('toast.templates.archiveError'), 'error')
    } finally {
      setIsArchiving(false)
    }
  }

  return { templateToArchive, setTemplateToArchive, isArchiving, handleArchive }
}
